import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListRentalBookings from "../Rental Booking/listRentalBooking";
import ListRequestPaymentsRefund from "../Rental Booking/requestPaymentRefund";
import ListRentalPayment from "../Rental Booking/listRentalPayment";
import "./headerRentalBooking.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "rental_booking_header_tab";

const HeaderRentalBooking = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "rental_booking_list"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "rental_booking_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("rental_booking_list")}
            >
              Rental Booking
            </h4>

            <h4
              className={selectedTable === "payment_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("payment_list")}
            >
              Refund Payment Request
            </h4>

            <h4
              className={selectedTable === "rental_payment" ? "clicked" : ""}
              onClick={() => handleTableSelection("rental_payment")}
            >
              Rental Payment
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "rental_booking_list" ? "block" : "none" }}>
            <ListRentalBookings />
          </div>

          <div style={{ display: selectedTable === "payment_list" ? "block" : "none" }}>
            <ListRequestPaymentsRefund />
          </div>

          <div style={{ display: selectedTable === "rental_payment" ? "block" : "none" }}>
            <ListRentalPayment />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderRentalBooking;
